// extracted by mini-css-extract-plugin
export default {"defaultNumberInput":"DefaultNumberInput_defaultNumberInput__7bkLJ","inputLabel":"DefaultNumberInput_inputLabel__SCnrM"};